/*
 * Reducer file for the UploadFiles slice
 * used for when searching and uploading files
 * adds to the files to array of files
 */

import { createSlice } from '@reduxjs/toolkit';
import { UploadFilesSlice } from './constants';
import type { FileAttachment } from '../../models/Document';

export interface UploadFilesState {
  files: FileAttachment[]
}

const initialState: UploadFilesState = {
  files: []
}

export const uploadFilesSlice = createSlice({
  name: UploadFilesSlice,
  initialState,
  reducers: {
    addFiles: (state, action) => {
      let files: FileAttachment[] = state.files;
      const filesToAdd: FileAttachment[] = action.payload.files;
      filesToAdd.forEach((fileToAdd: FileAttachment) => {
        if (!files.some((file: FileAttachment) => file.id === fileToAdd.id)) {
          files = [...files, fileToAdd];
        }
      });
      state.files = files;
    },
    editUploadedFile: (state, action) => {
      state.files = state.files.map((file: FileAttachment) =>
        file.id === action.payload.data.id
          ? { ...file, ...action.payload.data }
          : file
      );
    },
    removeFiles: (state, action) => {
      let files: FileAttachment[] = state.files;
      const filesToRemove: string[] = action.payload.files;
      if (filesToRemove.length > 0) {
        files = files.filter((file: FileAttachment) => !filesToRemove.includes(file.id));
      }
      state.files = files;
    },
    clearFiles: (state, action) => {
      state.files = [];
    }
  }
})

export const {
  addFiles, editUploadedFile, removeFiles, clearFiles
} = uploadFilesSlice.actions;
export default uploadFilesSlice.reducer;
